import styled from 'styled-components';

//color
export const editedSelectColor = '#0f2350';

export const editedInputColor = '#ea5506';

//styled-components
export const Root = styled.div`
  width: 80%;
  margin: 0 auto;
  padding: 5px;
`;
export const Message = styled.div`
  color: red;
`;
export const Explanation = styled.div`
  font-size: 11px;
  background-color: #ffffff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
`;
export const H3 = styled.h3`
  margin: 0;
`;
export const Hr = styled.hr`
  margin-top: 3px;
  margin-bottom: 3px;
  color: #d3381c;
`;
export const Textarea = styled.textarea`
  width: 100%;
`;
export const BrightButton = styled.input`
  padding: 5px;
  border-radius: 5px;
  background-color: #ee7800;
  margin: 0 auto;
  font-size: 20px;
  cursor: pointer;
  &:hover {
    background-color: #ffd900;
  }
`;

export const MyInfoWrapper = styled.div`
  width: 95%;
  margin: 0 auto;
  font-size: 11px;
  font-weight: bold;
  border-left: solid;
  border-left-width: 6px;
  border-left-color: #7c7c7c;
  background-color: #f5f5f5;
  margin-bottom: 12px;
  padding-left: 5px;
`;

export const MyInfoUpper = styled.div`
  text-align: left;
`;

export const MyInfoInput = styled.input`
  width: 98%;
  background-color: #eaeaea;
`;
export const PostNumberInput = styled.input`
  width: 100px;
  margin-bottom: 4px;
  background-color: #eaeaea;
  display: inline-block;
`;
export const MessageSelect = styled.div`
  color: ${editedSelectColor};
  display: inline-block;
`;

export const MessageInput = styled.div`
  color: #ea5506;
  display: inline-block;
`;

export const Select = styled.select`
  background-color: #89c3eb;
  margin-left: 5px;
  margin-bottom: 5px;
`;
